import { useMemo } from 'react';

import { useAppSelector, conversationsListState } from 'src/store';

export const useConversationsIsCollapsed = () => {
  const { isConversationListCollapsed } = useAppSelector(
    conversationsListState,
  );

  return useMemo(
    () => ({
      isConversationListCollapsed,
    }),
    [isConversationListCollapsed],
  );
};
